import React, { Component } from 'react';
import './TableOfContents.scss';
import data from '../../components/magazine.json';

class TableOfContents extends Component {
  render() {
    return (
      <div className={`d-flex align-items-center quote standard-padding ${this.props.classes}`}>
        <div className="content-wrapper table-of-contents">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    Introductie
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/astrael-is-anders-met-ambitie-en-dromen">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[0]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/duurzaamheid-kent-geen-tijd-brauer-groen-over-de-volgende-stap-in-groenbeheer">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[1]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/een-andere-kijk-op-een-duurzame-toekomst">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[2]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/behandelingen-voor-elk-huidtype-dat-verdient-een-schoonheidsprijs">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[3]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/partners-voor-service">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[4]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/mensen-uitdagen-om-tot-het-uiterste-te-gaan">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[5]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/van-onvoorstelbaar-naar-onweerstaanbaar-extended-reality-xr-maakt-het-verschil">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[6]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/influencers-bestaan-al-veel-langer-alleen-werden-ze-niet-zo-genoemd">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[7]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/5-tips-voor-het-gebruik-van-humor-op-social-media">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[8]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/space32-door-de-ogen-van-appart">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[9]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/space32-volgens-bart-jansen-het-is-voor-mij-een-denktank-van-twee-bedrijven-die-elkaar-aanvullen">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[10]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <a href="/appart-me/editie-9/designer-aan-het-woord-de-gedachte-achter-het-logo-van-space32">
                <div className="menu-item">
                  <div className="menu-item__image" />
                  <div className="menu-item__title">
                    { data.magazine.pages[11]["intro-title"] }
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default TableOfContents;
